import React from 'react';
import {
    Col, Row, Table, Modal, FormControl, FormGroup, ControlLabel, Form, OverlayTrigger, Tooltip
} from 'react-bootstrap';
import Select from 'react-select';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper.jsx';

class ModalSolicitud extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      solicitante: !this.props.solicitud ? this.props.userName : this.props.solicitud.solicitante,
      equipo: !this.props.solicitud ? '' : this.props.solicitud.equipo,
      dias: !this.props.solicitud ? [] : [...this.props.solicitud.dias],
      error: {},
      id: !this.props.solicitud ? null : this.props.solicitud.id,
    };
    this.saveSolicitud = this.saveSolicitud.bind(this);
    this.onChangeSolicitante = this.onChangeSolicitante.bind(this);
    this.onChangeEquipo = this.onChangeEquipo.bind(this);
    this.onChangeDias = this.onChangeDias.bind(this);
    this.showSelectedDays = this.showSelectedDays.bind(this);
    this.removeDay = this.removeDay.bind(this);
  }

  onChangeSolicitante(value) {
    const auxError = this.state.error;
    auxError['solicitante'] = false;
    this.setState({ error: auxError, solicitante: value });
  }

  onChangeEquipo(value) {
    console.log(value)
    const auxError = this.state.error;
    auxError['equipo'] = false;
    this.setState({ error: auxError, equipo: value });
  }

  onChangeDias(value) {
    const auxError = this.state.error;
    const auxDias = this.state.dias;
    auxDias.push(value);
    auxError['dias'] = false;
    this.setState({ error: auxError, dias: auxDias });
  }

  saveSolicitud() {
    const auxError = this.state.error;
    let error = false;
    auxError['solicitante'] = !this.state.solicitante || this.state.solicitante === '';
    auxError['equipo'] = !this.state.equipo || this.state.equipo === '';
    auxError['dias'] = !this.state.dias || this.state.dias.length === 0;

    if (!this.state.solicitante || this.state.solicitante === '') {
      auxError['solicitante'] = true;
      error = true;
    }
    if (!this.state.equipo || this.state.equipo === '') {
      auxError['equipo'] = true;
      error = true;
    }
    if (!this.state.dias || this.state.dias.length === 0) {
      auxError['dias'] = true;
      error = true;
    }

    if (error) {
      this.setState({error: auxError});
    } else {
      this.setState({error: {}});
      const solicitud = {
        solicitante: this.state.solicitante,
        equipo: this.state.equipo,
        dias: this.state.dias,
        id: this.state.id,
      }
      this.props.saveSolicitud(solicitud, this.props.closeModal);
    }
  }

  showSelectedDays() {
    if (this.state.dias.length === 0) {
      return (<div>No hay días seleccionados</div>);
    }
    const remove = (<Tooltip id="remove_tooltip">Eliminar</Tooltip>);

    // Sort dates
    const dates = this.state.dias.map((item, index) => {
      return {date: new Date(item.replace(/-/g, '/')), index};
    }).sort((a, b) => {
      return a.date<b.date ? -1 : a.date>b.date ? 1 : 0;
    });

    const html = dates.map((item, index) => {
      const displayDate = item.date.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
      return (
        <tr key={index}>
            <td>{displayDate.charAt(0).toUpperCase() + displayDate.slice(1)}</td>
            <td>
              <OverlayTrigger placement="top" overlay={remove}>
                <Button bsSize="xs" simple onClick={() => this.removeDay(item.index)}>
                  <i className="fa fa-times"></i>
                </Button>
              </OverlayTrigger>
            </td>
        </tr>
      );
    });
    return (
      <Table responsive={true}>
          <tbody>
              {html}
          </tbody>
      </Table>
    );
  }

  removeDay(index) {
    const auxState = this.state.dias;
    auxState.splice(index, 1);
    this.setState({ dias: auxState });
  }

  render() {
    const equipoList = this.props.equipmentList.map((item) => {
      return {value: item.id, label: item.nombre};
    });
    return (
      <Modal show onHide={() => this.props.closeModal()} style={{ display: "block" }}>
        <ModalBlockWrapper
          content = {
            <div>
              <Modal.Header closeButton>
                <Modal.Title>Solicitud de Equipamiento</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md={12}>
                    <Form horizontal>
                      <FormGroup validationState={this.state.error.solicitante ? 'error': null}>
                        <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                          Solicitante:
                        </Col>
                        <Col md={8}>
                          <FormControl
                            type="text" value={this.state.solicitante ? this.state.solicitante : ''}
                            onChange={(e) => this.onChangeSolicitante(e.target.value)}
                          />
                        </Col>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form horizontal>
                      <FormGroup validationState={this.state.error.equipo ? 'error': null}>
                        <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                          Equipo:
                        </Col>
                        <Col md={8}>
                          <Select
                            style={{ borderColor: this.state.error.equipo ? "#e40040" : "#aaa"}}
                            placeholder="Seleccione"
                            closeOnSelect={true}
                            multi
                            name="equipmentSelect"
                            value={this.state.equipo}
                            options={equipoList}
                            onChange={(value) => this.onChangeEquipo(value)}
                          />
                        </Col>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
                <Row style={{paddingTop: 10}}>
                  <Col md={12}>
                    <Form horizontal>
                      <FormGroup validationState={this.state.error.dias ? 'error': null}>
                        <Col componentClass={ControlLabel} md={4} style={{textAlign:'left'}}>
                          Selecciones los días:
                        </Col>
                        <Col md={8}>
                          <FormControl
                            type="date" value=""
                            onChange={(e) => this.onChangeDias(e.target.value)}
                          />
                          {this.showSelectedDays()}
                        </Col>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button simple onClick={this.props.closeModal}>
                  Cancelar
                </Button>
                <Button
                  bsStyle="success" fill onClick={this.saveSolicitud}
                >
                  Guardar
                </Button>
              </Modal.Footer>
            </div>
          }
        />
      </Modal>
    );
  }
}

export default ModalSolicitud;



// WEBPACK FOOTER //
// ./src/views/Administration/ModalSolicitud.jsx